import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-talanta-green text-white flex flex-col" data-testid="not-found-page">
      <div className="h-1 kenya-stripe" />
      <div className="flex-1 flex items-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="max-w-xl">
            <img src="/logo-knockout.png" alt="Talanta Hela" className="h-14 w-auto" />
            <div className="mt-10 inline-flex items-center gap-2 rounded-full bg-talanta-gold/15 border border-talanta-gold/30 px-4 py-1.5 text-talanta-gold text-xs font-semibold uppercase tracking-widest">
              <Compass className="h-3.5 w-3.5" /> 404 · Off the pitch
            </div>
            <h1 className="mt-5 font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
              This page hasn't been <span className="text-talanta-terracottaLight">scouted</span> yet.
            </h1>
            <p className="mt-5 text-white/70">The link may be old or mistyped. Head back to the front door and explore the six pillars.</p>
            <Link
              to="/"
              data-testid="not-found-home-link"
              className="mt-8 inline-flex items-center rounded-full bg-talanta-red hover:bg-talanta-red/90 px-7 py-3.5 font-semibold shadow-xl shadow-black/30 transition-all hover:scale-[1.03]"
            >
              Back to Talanta Hela
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
